import React, { useState, useEffect, useRef } from 'react'
import 'antd/lib/style/index.css'
import zhCN from 'antd/lib/locale/zh_CN'
import css from './user-center.module.less'
import {
  ConfigProvider,
  Modal,
  Button,
  Input,
  message,
  Row,
  Col,
} from 'antd'


import { sendHttpPostRequest } from '../../../api/http-request'
import type { DraggableData, DraggableEvent } from 'react-draggable'

import { BACKEND_API_URL } from '../../../constants/constants'
import Draggable from 'react-draggable'
import { CalendarOutlined, SettingOutlined } from '@ant-design/icons'

const { TextArea } = Input


interface Props {}



export const MyCollege: React.FC<Props> = (props: Props) => {

  const [disabled, setDisabled] = useState(false)
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const draggleRef = useRef<HTMLDivElement>(null)

  const [currentCollege, setCurrentCollege] = useState(null as any) //当前的机构
  const [myCollegeList, setMyCollegeList] = useState([] as any[]) //我的机构列表
  const [schoolCode, setSchoolCode] = useState('') //
  const [applyNumberVisible, setApplyNumberVisible] = useState(false) //申请院校码弹出框
  const [applySubmitVisible, setApplySubmitVisible] = useState(false) //申请提交弹出框
  const [applyCollegeCode, setApplyCollegeCode] = useState(0) // 是否申请院校码
  const [applyUserName, setApplyUserName] = useState('')
  const [applyUserPhone, setApplyUserPhone] = useState('')
  const [collegesAndDepartments, setCollegesAndDepartments] = useState('')
  const [applyUserDuties, setApplyUserDuties] = useState('')
  const [studentCount, setStudentCount] = useState('')
  const [applyUserMajor, setApplyUserMajor] = useState('')
  const [applyReason, setApplyReason] = useState('')


  useEffect(() => {
    queryCollegeInfo()
    return () => {}
  }, [])



  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement
    const targetRect = draggleRef.current?.getBoundingClientRect()
    if (!targetRect) {
      return
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    })
  }


 

  /**
   * 查询院校码申请
   */
  const queryCollegeCodeApply = () => {
    let _data = {
      college_code: schoolCode,
    }
    const _url = 'account/api/user_query_college_code_apply'
    sendHttpPostRequest(_url,_data, 
      (data) => {
        message.destroy()
        if (data.code == -2) {
          // 未申请过院校码
          setApplyCollegeCode(0)
        } else if (data.code == 0) {
          // 已申请过院校码
          setApplyCollegeCode(1)
        } else {
          setApplyCollegeCode(0)
        }
      })
    
  }

  //用户加入院校
  const userJoinCollege = () => {
    let _data = {
      college_code: schoolCode,
    }
    const _url = 'college/api/user_join_college_by_code/'
    sendHttpPostRequest( _url,_data,
      (data) => {
        message.destroy()
        if (data.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (data.is_ok == true) {
          const college_role = data.college_role == 2 ? '教师' : '学生'
          message.success(
            '加入院校' + data.college_name + ',身份:' + college_role,
          )

          localStorage.removeItem('user_info')
          setTimeout(function () {
            window.location.reload()
          }, 1000)
        } else {
          message.error(data.message)
        }
      })
    
  }

  const queryCollegeInfo = () => {
    let _data = {
      college_code: schoolCode,
    }
    let _url = 'account/api/query_teacher_authenticate'
    sendHttpPostRequest( _url, _data,
      (data) => {
        message.destroy()
        if (data?.is_ok == true) {
          setMyCollegeList(data.college_list)
          setCurrentCollege(data.college_info)
        }
        queryCollegeCodeApply()
      })
      
  }

  const addCollegeCodeApply = () => {
    let _data = {
      apply_user_phone: applyUserPhone,
      colleges_and_departments: collegesAndDepartments,
      apply_user_duties: applyUserDuties,
      student_count: studentCount,
      apply_user_major: applyUserMajor,
      apply_reason: applyReason,
    }
    const _url = 'account/api/user_add_college_code_apply'
    sendHttpPostRequest( _url,_data,
      (data) => {
        message.destroy()
        if (data.is_ok) {
          setApplyCollegeCode(1)
          setTimeout(function () {
            setApplySubmitVisible(false)
          }, 2000)
        } else {
          setApplySubmitVisible(false)
          message.error('申请失败，请稍候再试')
        }
      })
      
  }

  //用户切换机构
  const handleChangeCollege = (value: any) => {
    let _data = {
      college_id: value,
    }
    const _url = 'college/api/user_swift_college/'
    sendHttpPostRequest( _url,_data,
     (data) => {
        message.destroy()
        if (data.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (data.is_ok == true) {
          
          localStorage.removeItem('user_info')
          localStorage.removeItem('college_info')
          setCurrentCollege(
            myCollegeList?.filter((item) => item.college_id == value)[0],
          )
          queryCollegeInfo()
          message.success('院校切换成功~')
    
        } else {
          message.error(data.message)
        }
      })
     
  }



  return (
      <div
        style={{
          position: 'relative',
          border:'none',
          color: '#333',

        }}
      >

        {/** 当前激活机构 */}
        { currentCollege?.college_id && <div style={{border: '1px solid rgb(243 244 246)', boxShadow:'0 4px 20px rgba(0, 0, 0, .08', borderRadius:8, padding:24}}>

          <Row wrap={false} align='middle' >
            <Col span={20} style={{textAlign:'left'}}>
              <div>
                <div className={css.collegeBoxTitle}  >当前激活机构 </div>
                <div  className={css.collegeBoxDesp} style={{marginBottom:24}} >您当前正在使用该机构的服务</div>
              </div>
            </Col>

          </Row>

          <div className={css.collegeCard}>

          <Row wrap={false} align='middle' >
            <Col flex="200px" style={{marginRight:16}}>
                <div>
                  <img
                      style={{ width: 200, height: 40 }}
                      src={
                        currentCollege?.logo_url?.startsWith('http')
                          ? currentCollege?.logo_url
                          : BACKEND_API_URL+ currentCollege?.logo_url
                      }
                    />
                </div>
            </Col>
            <Col flex="auto">
              <div>

                <Row wrap={false} align='middle'>
                  <Col span={20} style={{textAlign:'left'}}>

                    <div style={{maxWidth:450}} className={css.mainCollegeTitle} title={currentCollege?.college_name}>{currentCollege?.college_name}
                    
                    <span
                        style={{fontSize:18,marginLeft:16,padding:'5px 10px', color:'#07c160', background:'#07c1601a', borderRadius:16}}
                      > {currentCollege?.is_college_teacher == 1 ? "教师" :"学生"} </span>
                      
                      </div>
                  </Col>
                  

                  <Col span={4} style={{textAlign:'right'}}>
                    { currentCollege?.is_manager == 1 && <div  className={css.manageOAMCollegeBtnDiv}>
                      <SettingOutlined  style={{marginRight:6}}/>
                      <span
                        onClick={()=>{window.open('/college-oam')}}
                      > 机构管理 </span>
                    </div>}
                  </Col>
                </Row>  

                <div className={css.mainCollegeDesp} title={currentCollege?.introduction}>
                  {currentCollege?.introduction}
                </div>

                <Row wrap={false} align='middle' style={{margin:'16px 0 0'}}>
                  <Col flex="32px" style={{ marginRight:10}}>
                    <div>
                      <img
                        style={{ width: 32, height: 32 , borderRadius:'50%'}}
                        src={
                          currentCollege?.manager_avatar?.startsWith('http')
                            ? currentCollege?.manager_avatar
                            : BACKEND_API_URL+ currentCollege?.manager_avatar
                        }
                      />
                    </div>
                  </Col>
                  {/** 机构管理员 */}
                  <Col flex="200px">
                    <div style={{fontSize:12, color:'#6b7280'}}> 机构管理员</div>
                    <div style={{fontSize:16, color:'#1d2129', fontWeight:500}}>
                      {currentCollege?.manager_real_name? currentCollege?.manager_real_name:currentCollege?.manager_name}
                    </div>
                  </Col>
                  {/** 加入时间 */}
                  <Col flex="32px" style={{ marginRight:10}}>
                    <div style={{lineHeight:'32px',textAlign:'center',color:'#07c160',height:32, width:32, borderRadius:'50%', background:'#07c1601a'}}>
                      <CalendarOutlined />
                    </div>
                  </Col>
                  <Col flex="auto">
                    <div style={{fontSize:12, color:'#6b7280'}}> 加入时间 </div>
                    <div style={{fontSize:16, color:'#1d2129', fontWeight:500}}>
                      {currentCollege?.join_time}
                    </div>
                  </Col>

                </Row>  

              </div>
            </Col>

            </Row>
          </div>

        </div> }

        {/** 其他加入的机构 */}
        {myCollegeList.length >0 && myCollegeList[0]?.college_id && <div style={{marginTop:40}}>
          <div  className={css.collegeBoxTitle}    >其他加入的机构</div>
          <div  className={css.collegeBoxDesp} style={{marginBottom:24}}>您加入的其他机构，可随时切换激活状态</div>

          <Row justify='space-between' gutter={[24,24]}>
            {myCollegeList?.map((college) => {
                if(college.college_id == currentCollege?.college_id){
                  return null
                }else{
                return (
                  <Col span={12} key={college.college_id} >
                    <div className={css.otherCollegeCard}>
                      <Row wrap={false} align='middle' >
                        <Col flex="130px" style={{marginRight:16}}>
                            <div>
                              <img
                                  style={{ width: 120, height: 30 }}
                                  src={
                                    college?.logo_url?.startsWith('http')
                                      ? college?.logo_url
                                      : BACKEND_API_URL+ college?.logo_url
                                  }
                                />
                            </div>
                        </Col>
                        <Col flex="auto">
                          <div>

                            <Row wrap={false} align='middle'>
                              <Col span={20} style={{textAlign:'left'}}>
                                <div className={css.otherCollegeTitle} title={college?.college_name}>{college?.college_name}</div>
                              </Col>
                              <Col span={4} style={{textAlign:'right'}}>
                                <div>
                                  <span
                                    className={css.set2activeCollege}
                                    onClick={()=>{handleChangeCollege(college?.college_id)}}
                                  > 设为激活 </span>
                                </div>
                              </Col>
                            </Row>  

                            <div className={css.otherCollegeDesp}>
                              {college?.introduction}
                            </div>

                            <Row wrap={false} align='middle' style={{margin:'16px 0 0',color:'#6b7280',fontSize:14}}> 
                              <Col flex="24px" style={{marginRight:5}}> 
                                <div>
                                  <img
                                    style={{ width: 24, height: 24 ,borderRadius:'50%'}}
                                    src={
                                      college?.manager_avatar?.startsWith('http')
                                        ? college?.manager_avatar
                                        : BACKEND_API_URL + college?.manager_avatar
                                    }
                                  />
                                </div>
                              </Col>
                              <Col flex="100px">
                                <div>
                                  {college?.manager_real_name? college?.manager_real_name:college?.manager_name}
                                </div>
                              </Col>

                              {/** 加入时间 */}
                              <Col flex="24px" style={{marginRight:5}}>
                              <div style={{lineHeight:'24px',textAlign:'center',color:'#07c160',height:24, width:24, borderRadius:'50%', background:'#07c1601a'}}>
                                  <CalendarOutlined />
                                </div>
                              </Col>
                              <Col flex="auto">
                                <div >
                                  {currentCollege?.join_time}
                                </div>
                              </Col>

                            </Row>  

                          </div>
                        </Col>

                      </Row>
                    </div>
                  </Col>
                )
              }
              })}

          </Row>

        </div> }

        {/** 加入新机构 */}
        <div style={{border: '1px solid rgb(243 244 246)', boxShadow:'0 4px 20px rgba(0, 0, 0, .08)', borderRadius:8, padding:24, margin: '40px 0'}}>
          <div  className={css.collegeBoxTitle}  >加入新机构</div>
          <div  className={css.collegeBoxDesp} style={{marginBottom:24}} >输入机构邀请码加入新的机构</div>
          <div style={{marginBottom:8}}>院校码</div>
          <div style={{ position: 'relative', display:'flex' }}>
            <Input
              style={{padding:'8px 16px',  borderRadius:'8px 0 0 8px',height:42,fontSize:16}}
              placeholder="请输入院校码"
              value={schoolCode}
              className={css.selectStyle}
              onChange={(e: any) => {
                setSchoolCode(e.target.value)
              }}
            />

            <Button
              onClick={userJoinCollege}
              type="default"
              style={{marginLeft:-1, borderRadius:'0 8px 8px 0', height:42, width:80,fontSize:16,background:'#07c160', color:'#fff'}}
            >
              提交
            </Button>

            {!currentCollege?.college_id && !myCollegeList[0]?.college_id && (
              <Button
                type="default"
               
                style={{height:42,borderRadius:8, fontSize:16,color:'#07c160',borderColor:'#07c160', marginLeft:20}}
                onClick={() => {
                  applyCollegeCode == 0
                    ? setApplyNumberVisible(true)
                    : setApplySubmitVisible(true)
                  setTimeout(function () {
                    setApplySubmitVisible(false)
                  }, 2000)
                }}
              >
                申请院校码
              </Button>
            )}

          </div>

          <div style={{marginTop:8, color:'rgb(107 114 128)', fontSize:12}} >院校码由机构管理员生成并提供</div>

        </div>


        <ConfigProvider locale={zhCN}>

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#333' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                申请院校码
              </div>
            }
            width={450}
            bodyStyle={{
              minHeight: 588,
            }}
            className={css.ModalTip}
            closable={true}
            centered={true}
            open={applyNumberVisible}
            onCancel={() => {
              setApplyNumberVisible(false)
            }}
            footer={[]}
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div
              style={{ width: '100%', textAlign: 'left', color: '#333' }}
            >
              <div style={{ textAlign: 'left', marginBottom: 20 }}>
                该平台面向全国高校师生提供服务,“院校码”用于认证平台用户的院校身份。如需申请，请如实填写以下信息。
              </div>
              <Row justify="start" align="middle" className={css.row}>
                <Col flex={'76px'}>真实姓名</Col>
                <Col flex={'auto'}>
                  {' '}
                  <Input
                    className={css.modalLargInput}
                    placeholder="请输入名字"
                    value={applyUserName}
                    onChange={(e: any) => {
                      setApplyUserName(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <Row justify="start" align="middle" className={css.row}>
                <Col flex={'76px'}>手机号</Col>
                <Col flex={'auto'}>
                  {' '}
                  <Input
                    className={css.modalLargInput}
                    placeholder="请输入手机号"
                    value={applyUserPhone}
                    onChange={(e: any) => {
                      setApplyUserPhone(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <Row justify="start" align="middle" className={css.row}>
                <Col flex={'76px'}>所在院校</Col>
                <Col flex={'auto'}>
                  <Input
                    className={css.modalLargInput}
                    placeholder="所在学校和院系"
                    value={collegesAndDepartments}
                    onChange={(e: any) => {
                      setCollegesAndDepartments(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <Row justify="start" align="middle" className={css.row}>
                <Col flex={'76px'}>授课专业</Col>
                <Col flex={'auto'}>
                  <Input
                    placeholder="授课专业"
                    value={applyUserMajor}
                    onChange={(e: any) => {
                      setApplyUserMajor(e.target.value)
                    }}
                    className={css.modalLargInput}
                  />
                </Col>
              </Row>
              <Row justify="start" align="middle" className={css.row}>
                <Col flex={'76px'}>职务</Col>
                <Col flex={'auto'}>
                  <Input
                    className={css.modalLargInput}
                    placeholder="职务"
                    value={applyUserDuties}
                    onChange={(e: any) => {
                      setApplyUserDuties(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <Row justify="start" align="middle" className={css.row}>
                <Col flex={'76px'}>使用人数</Col>
                <Col flex={'auto'}>
                  <Input
                    className={css.modalLargInput}
                    placeholder="使用人数"
                    value={studentCount}
                    onChange={(e: any) => {
                      setStudentCount(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <Row justify="start" align="middle" className={css.row}>
                <Col flex={'76px'}>备注信息</Col>
                <Col flex={'auto'}>
                  <TextArea
                    className={css.modalLargInput}
                    placeholder="备注信息"
                    value={applyReason}
                    onChange={(e: any) => {
                      setApplyReason(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <div className={css.submitContain}>
                <Button
                  style={{ width: 320, marginTop: 20, color: '#fff' }}
                  type="primary"
                  onClick={() => {
                    setApplyNumberVisible(false)
                    setApplySubmitVisible(true)
                    addCollegeCodeApply()
                  }}
                >
                  提交
                </Button>
              </div>
            </div>
          </Modal>
          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#333' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                提示
              </div>
            }
            width={350}
            className={css.whiteModal}
            closable={false}
            centered={true}
            visible={applySubmitVisible}
            footer={[]}
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div style={{ width: 300, textAlign: 'center', color: '#333' }}>
              已成功提交，会有专员与您联系。
            </div>
          </Modal>
        </ConfigProvider>

      </div>
  )
}

export default MyCollege
